/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getHostStatus.defs'
export { main as default } from './getHostStatus.defs'
